module.exports = "https://coursera_assets.s3.amazonaws.com/images/bcd97cd032bec9173f91970596effccb.svg";